import LDS_AUTOCMPLETE_CITIES from "../assets/Data/LdsAirportsAutocomplete"

const translateLDSDestinations = ( destination = "" ) => {
  const translate =  LDS_AUTOCMPLETE_CITIES.find(({CITYCODE}) =>
    CITYCODE?.toLowerCase() === destination.toLowerCase()
  );
  return translate || ""
};

let cityNameIndex = null;

function getCityNameIndex() {
  if (cityNameIndex) return cityNameIndex;
  const index = new Map();
  for (const row of LDS_AUTOCMPLETE_CITIES) {
    const name = String(row?.CITYNAME || "").trim().toUpperCase();
    if (name && !index.has(name)) index.set(name, row);
  }
  cityNameIndex = index;
  return index;
}

/** CITYCODE first, then unique CITYNAME (e.g. PROTARAS → פרוטארס). */
export function translateLDSDestinationByNameOrCode(destination = "") {
  const byCode = translateLDSDestinations(destination);
  if (byCode) return byCode;
  const nameKey = String(destination ?? "").trim().toUpperCase();
  if (!nameKey) return "";
  return getCityNameIndex().get(nameKey) || "";
}

export default translateLDSDestinations;
